import { render, staticRenderFns } from "./CopyTo.vue?vue&type=template&id=38e2c047&scoped=true&"
import script from "./CopyTo.vue?vue&type=script&lang=js&"
export * from "./CopyTo.vue?vue&type=script&lang=js&"
import style0 from "./CopyTo.vue?vue&type=style&index=0&id=38e2c047&scoped=true&lang=css&"
import style1 from "./CopyTo.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38e2c047",
  null
  
)

export default component.exports